import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c0a8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "exam-tip" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag" }, null, -1))
const _hoisted_6 = { class: "exam-type" }
const _hoisted_7 = { class: "exam-score" }
const _hoisted_8 = { class: "exam-num" }
const _hoisted_9 = { class: "exam-content" }
const _hoisted_10 = { class: "exam-title" }
const _hoisted_11 = { class: "exam-options" }
const _hoisted_12 = { class: "exam-result" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 您选择的答案是：")
const _hoisted_14 = { class: "checked-value" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "exam-tip" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "tag" }),
    /*#__PURE__*/_createElementVNode("span", { class: "exam-type" }, "提示")
  ])
], -1))
const _hoisted_18 = { class: "tip-cont" }
const _hoisted_19 = { class: "btn-box" }
const _hoisted_20 = { class: "dialog-content" }
const _hoisted_21 = { class: "score-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    (_ctx.examData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.examData[_ctx.questionNum - 1].type == 1
                ? "单选题"
                : _ctx.examData[_ctx.questionNum - 1].type == 2
                ? "判断题"
                : "多选题"), 1),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(_ctx.examData[_ctx.questionNum - 1].score) + "分)", 1)
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.questionNum) + " / " + _toDisplayString(_ctx.examData.length), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, _toDisplayString(_ctx.questionNum) + ".", 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.examData[_ctx.questionNum - 1].content), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.examData[_ctx.questionNum - 1].type == 3)
                  ? (_openBlock(), _createBlock(_component_van_checkbox_group, {
                      key: 0,
                      modelValue: _ctx.answerMap[_ctx.examData[_ctx.questionNum - 1].id],
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.answerMap[_ctx.examData[_ctx.questionNum - 1].id]) = $event)),
                      onChange: _ctx.changeCheckbox
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answeroption, (li, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "checkbox-item",
                            key: i
                          }, [
                            _createVNode(_component_van_checkbox, {
                              name: String.fromCharCode(i + 65),
                              "checked-color": "#3F55F7",
                              shape: "square"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(String.fromCharCode(i + 65)) + "、 " + _toDisplayString(li), 1)
                              ]),
                              _: 2
                            }, 1032, ["name"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]))
                  : (_openBlock(), _createBlock(_component_van_radio_group, {
                      key: 1,
                      modelValue: _ctx.answerMap[_ctx.examData[_ctx.questionNum - 1].id],
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.answerMap[_ctx.examData[_ctx.questionNum - 1].id]) = $event)),
                      onChange: _ctx.changeRadio
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answeroption, (li, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "checkbox-item"
                          }, [
                            _createVNode(_component_van_radio, {
                              "checked-color": "#3F55F7",
                              name: String.fromCharCode(i + 65)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(String.fromCharCode(i + 65)) + "、" + _toDisplayString(li), 1)
                              ]),
                              _: 2
                            }, 1032, ["name"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(this.answer), 1)
                ]),
                _createElementVNode("img", {
                  class: "tip-btn",
                  src: require('@/assets/exam/tip.png'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bShowTip = !_ctx.bShowTip))
                }, null, 8, _hoisted_15)
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.examData[_ctx.questionNum - 1].tip), 1)
          ], 512), [
            [_vShow, _ctx.bShowTip]
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.questionNum != 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "upper-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.turnpage(-1)))
                }, " 上一题 "))
              : _createCommentVNode("", true),
            (_ctx.questionNum !== _ctx.examData.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "under-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.turnpage(1)))
                }, " 下一题 "))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "under-btn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.subtestvalue && _ctx.subtestvalue(...args)))
                }, "交卷"))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_dialog, {
      show: _ctx.dialogShow,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogShow) = $event)),
      title: "测试结果",
      showConfirmButton: false,
      "show-cancel-button": "",
      cancelButtonText: "关闭",
      onClose: _ctx.fDialogOpen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'exam-svg': _ctx.score === 1, 'noexam-svg': _ctx.score === 0 })
          }, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.score ? "通过" : "不通过"), 1)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ]))
}